// Core
import useSWR from "swr";

// Definitions
import type { GameListType, GamesFilterParamsType, GameType } from "../types";
import type { HttpResponseAxiosDataType, HttpResponseAxiosErrorType } from "@/types/http";
import { PaginationType } from "@/types/basic";

// Utils
import { gamesApi } from "../service";
import { gamesKeys } from "../apiKeys";

type UseGamesFetchType = {
  loadingGamesFetch: boolean;
  games: GameType[];
  pagination: PaginationType | null;
};

const fetcher = (params?: GamesFilterParamsType) => () => gamesApi.fetchGames({ params });

export const useGamesFetch = (props: GamesFilterParamsType): UseGamesFetchType => {
  const { data, isLoading, isValidating } = useSWR<
    HttpResponseAxiosDataType<GameListType>,
    HttpResponseAxiosErrorType
  >([gamesKeys.games, props], fetcher(props ? props : void 0));
  return {
    loadingGamesFetch: isLoading || isValidating,
    games: data?.data?.items || [],
    pagination: data?.data?.meta || null,
  };
};
